const Fashion = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="text-[40px] font-bold">TCS Fashion</h1>
      </div>
      <div className="flex flex-col justify-center  gap-8 max-w-[50rem] mx-auto  p-[3rem]">
        <h1 className="flex justify-center items-center font-bold">
          Comming Soon
        </h1>

        <p>For further details, please contact us at 111-123-456.</p>
      </div>
    </div>
  );
};

export default Fashion;
